import { Component } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { sharedAddress } from '../../form-parts-definition';
import { AddressHint, addressHintToModel, resolveOwnerId } from '../../hints';

@Component({
  selector: 'tpa-address',
  templateUrl: './address.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class AddressComponent extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      full: true,
      open: false,
    },
  };

  get emptyModel() {
    return !this.model || JSON.stringify(this.model) === '{}';
  }

  /** Card owner id (the employee being edited), for offering their own historical addresses. */
  get ownerId(): number | null {
    return resolveOwnerId(this.options?.formState);
  }

  /** Quick-fills this address from a picked historical address. */
  fillFromHint(hint: AddressHint) {
    this.formControl?.patchValue(addressHintToModel(hint));
  }

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = sharedAddress();

  }
}
